import React, { Component } from "react";
import auth from "../Auth";
import GPAP_LOGO from "../../gpap-lib/img/3TR_logo_final.png";
import { NavLink } from "react-router-dom";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";

import { OrangeTextButton } from "../../gpap-lib/Button_Collection";
import GPAP_BREADCRUMB from "../../gpap-lib/GPAP_Breadcrumb";
import "./navigation-bar.css";
import LogoutButton from "./LogoutButton";

// TODO
// figure out for what GPAP_Breadcrumb is needed

export class NavigationBar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      keycloak: auth.user.keycloak,
      authenticated: auth.user.authenticated,
    };
  }

  render() {
    let welcome = "Welcome Guest";
    if (auth.user.authenticated) {
      welcome = `Welcome ${auth.user.keycloak.tokenParsed.name}`;
    }

    const SUBMISSION =
      window.location.href.includes("submission") ||
      window.location.href.includes("submit") ||
      window.location.href.includes("selectproject");

    return (
      <div className="pageHeader">
        <Grid container spacing={2}>
          <Grid item xs={5}>
            <Grid item>
              {SUBMISSION ? (
                <OrangeTextButton
                  className={{ a: { color: "orange" } }}
                  href={"#/submission"}
                >
                  Data Submission
                </OrangeTextButton>
              ) : (
                <Button href={"#/submission"}>Data Submission</Button>
              )}
              {!SUBMISSION ? (
                <OrangeTextButton
                  className={{ a: { color: "orange" } }}
                  href={"#/datasets"}
                >
                  Data Management
                </OrangeTextButton>
              ) : (
                <Button href={"#/datasets"}>Data Management</Button>
              )}
            </Grid>
            <Grid item>
              <GPAP_BREADCRUMB />
            </Grid>
          </Grid>
          <Grid item xs={2} style={{ textAlign: "center" }}>
            <div>
              <NavLink exact to="/" style={{ color: "black" }}>
                <img src={GPAP_LOGO} className="logo" alt="3tr" />
              </NavLink>
            </div>
          </Grid>
          <Grid item xs={5} style={{ textAlign: "center" }}>
            <div className="header-right">
              <Button>
                <NavLink exact to="#">
                  {welcome}
                </NavLink>
              </Button>
              <LogoutButton />
              <Button>
                <NavLink
                  exact
                  to="faq"
                >
                  FAQ
                </NavLink>
              </Button>
              <div className={"navbar_links"} />
            </div>
          </Grid>
        </Grid>
      </div>
    );
  }
}
